import { Component, Inject, OnDestroy, OnInit, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { SidePanelService } from './side-panel.service';
import { Observable, Subscription } from 'rxjs';
import { LoadingService } from '../loading.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PSIC_COMPONENTS } from '@pacificspecialtyinsurancecompany/psic-ng-components';

@Component({
    selector: 'app-side-panel',
    templateUrl: './side-panel.component.html',
    styleUrls: ['./side-panel.component.scss'],
    imports: [CommonModule, MatDialogModule, MatIconModule, ...PSIC_COMPONENTS, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelComponent implements OnDestroy {
    form: UntypedFormGroup;
    headerTemplate: TemplateRef<any>;
    contentTemplate: TemplateRef<any>;
    totalTemplate: TemplateRef<any>;
    footerTemplate: TemplateRef<any>;
    data: any;
    sidePanelService: SidePanelService;
    sink = new Subscription();
    loading$: Observable<boolean>;

    constructor(
        private dialogRef: MatDialogRef<SidePanelComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private loadingService: LoadingService
    ) {
        this.loading$ = this.loadingService.getLoadingStatus();

        this.sidePanelService = data.sidePanelService;

        this.sink.add(
            this.sidePanelService.updateData$.subscribe((data) => {
                if (data) {
                    this.data = data;
                }
            })
        );

        this.dialogRef.disableClose = true;
        this.form = data.form;
        this.headerTemplate = data.headerTemplate;
        this.totalTemplate = data.totalTemplate;
        this.footerTemplate = data.footerTemplate;
        this.contentTemplate = data.contentTemplate;
        this.data = data.data;
    }

    onClose() {
        if (this.sidePanelService) {
            this.sidePanelService.closeClicked.next(this.data);
        } else {
            this.dialogRef.close(this.data);
        }
    }

    onCancel() {
        if (this.sidePanelService) {
            this.sidePanelService.cancelClicked.next(this.data);
        }
    }

    onSave() {
        if (this.sidePanelService) {
            this.sidePanelService.saveClicked.next(this.data);
        }
    }

    ngOnDestroy(): void {
        this.sink.unsubscribe();
    }
}
